import { render, staticRenderFns } from "./SubmitIndicator.vue?vue&type=template&id=00efeb12&scoped=true&"
import script from "./SubmitIndicator.vue?vue&type=script&lang=ts&"
export * from "./SubmitIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitIndicator.vue?vue&type=style&index=0&id=00efeb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efeb12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
